module.exports = __webpack_public_path__ + "af5a74dd95743f28c9a857d91a913dc0.jpg";